import React, { useEffect } from "react";
import Header from "./Header";
import "../../src/vaporWaveMode.css";

const THEME_KEY = "theme";
const THEME_MODE_KEY = "themeMode";
const DARK_THEME = "vaporWaveAlt";
const LEGACY_DARK_THEME = "vaporWave";
const LIGHT_THEME = "light";

function Theme() {
  useEffect(() => {
    const { classList } = document.body;

    // Vaporwave mode is temporarily disabled; always render the light theme.
    classList.remove(DARK_THEME, LEGACY_DARK_THEME);
    classList.add(LIGHT_THEME);
    localStorage.removeItem(THEME_KEY);
    localStorage.removeItem(THEME_MODE_KEY);

    return () => {
      classList.remove(LIGHT_THEME, DARK_THEME, LEGACY_DARK_THEME);
    };
  }, []);

  return <Header />;
}

export default Theme;
